import {Pipe, PipeTransform} from '@angular/core'

@Pipe({
  name: 'filesize',
})
export class FilesizePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (!value) return value

    var k = 1000,
      dm = args || 1,
      sizes = ['Bytes', ' KB', ' MB', ' GB', ' TB', ' PB', ' EB', ' ZB', ' YB'],
      i = Math.floor(Math.log(value) / Math.log(k))
    return parseFloat((value / Math.pow(k, i)).toFixed(dm)) + sizes[i]
  }
}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/pipe/filesize.pipe.ts